module.exports = __webpack_public_path__ + "img/storyline-logo-white.c66d53f8.svg";